import { useSetLocationData } from "~/hooks/locationData";
import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";

export const usePaginationParams = (
  variant: "locationData" | "urlParams" = "locationData",
) => {
  const setLocationData = useSetLocationData();
  const setURLParams = useURLParamsSetter();

  if (variant === "urlParams") {
    return {
      handleCount: (n: number) =>
        setURLParams({ count: String(n || 25), page: "0" }),
      handlePage: (n: number) =>
        setURLParams({ page: String(Math.max(0, (n || 1) - 1)) }),
    };
  }

  return {
    handleCount: (n: number) => setLocationData("count", n || 25, "page", 0),
    handlePage: (n: number) =>
      setLocationData("page", Math.max(0, (n || 1) - 1)),
  };
};
